document.addEventListener('DOMContentLoaded', async function () {
    console.log("Script initialized");

    const hiddenVariantElement = document.querySelector('.hide_variant_id');
    let hiddenVariantId = hiddenVariantElement ? hiddenVariantElement.value : null;

    // Store hidden variant ID in localStorage when on product page
    if (hiddenVariantId) {
        localStorage.setItem('hiddenVariantId', hiddenVariantId);
        console.log(`Stored hidden variant ID: ${hiddenVariantId}`);
    } else {
        // Retrieve hiddenVariantId when not on product page
        hiddenVariantId = localStorage.getItem('hiddenVariantId');
        console.log(`Retrieved hidden variant ID from storage: ${hiddenVariantId}`);
    }

    if (!hiddenVariantId) {
        console.log(" No hiddenVariantId found. Exiting script.");
        return;
    }

    /**
     * Fetch cart data using Zipify OCU API and check if hidden variant is in cart
     */
    async function checkCartForHiddenVariant() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();

            const productInCart = cart.items.some(item => String(item.variant_id) === hiddenVariantId);
            console.log(`Is hidden product in cart? ${productInCart}`);

            return productInCart;
        } catch (error) {
            console.error(" Error fetching cart data:", error);
            return false;
        }
    }

    /**
     * Disable Add to Cart button and Quantity buttons if hidden variant is in cart
     */
    async function disableButtonsIfProductInCart() {
        const isProductInCart = await checkCartForHiddenVariant();

        // Disable quantity controls on **Product Page** if needed
        const productPageInput = document.querySelector('input[name="id"]');
        if (productPageInput && productPageInput.value === hiddenVariantId) {
            document.querySelectorAll('.ocu-quantity-plus, .ocu-quantity-minus, .quantity__button').forEach(button => {
                button.disabled = true;
            });

            // Disable Add to Cart button for this product
            const productPageAddToCart = document.querySelector('.product-form__submit');
            if (productPageAddToCart) {
                productPageAddToCart.disabled = isProductInCart;
                productPageAddToCart.textContent = isProductInCart ? "Already in Cart" : "Add to Cart";
                console.log(`Add to Cart button disabled: ${isProductInCart}`);
            }
        }

        // Disable quantity controls on **Cart Page & Cart Drawer**
        const cartItems = document.querySelectorAll('.ocu-cart-line-item-wrapper');
        cartItems.forEach(item => {
            const productLink = item.querySelector('a.ocu-cart-line-item-image, a.ocu-cart-line-item-product-title');
            if (productLink) {
                const variantId = new URL(productLink.href, window.location.origin).searchParams.get('variant');
                if (variantId === hiddenVariantId) {
                    item.querySelectorAll('.ocu-quantity-plus, .ocu-quantity-minus, .quantity__button').forEach(button => {
                        button.disabled = true;
                    });
                    console.log(`Disabled quantity controls for product ${hiddenVariantId} in cart`);
                }
            }
        });
    }

    /**
     * Handle Add to Cart with Zipify OCU API
     */
    Zipify.OCU.api.customAddToCartEventHandler = async (button) => {
        console.log("Custom Add to Cart triggered");

        const productData = Zipify.OCU.api.getCustomAddToCartData?.() ?? {};
        if (productData.id === hiddenVariantId) {
            console.log("Restricted product attempted to be added. Preventing.");
            return; // Block adding the product more than once
        }

        button.disabled = false;
        button.click(); // Alternatively: button.dispatchEvent(new PointerEvent('click', { cancelable: true, bubbles: true }));

        setTimeout(disableButtonsIfProductInCart, 1000); // Check cart after adding
    };

    /**
     * Observe Cart Drawer Open Event
     */
    function observeCartDrawer() {
        const observer = new MutationObserver(() => {
            if (document.body.classList.contains('ocu-overflow-hidden')) {
                console.log("🛒 Cart drawer opened. Running check...");
                disableButtonsIfProductInCart();
            }
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    /**
     * Override Zipify Add to Cart Fetch
     */
    Zipify.OCU.api.customAddToCartFetch = async ({ url, method, data }) => {
        try {
            const body = JSON.stringify(data);
            const options = { method, body, headers: { 'Content-Type': 'application/json' } };

            const response = await fetch(url, options);
            const cart = await response.json();

            setTimeout(disableButtonsIfProductInCart, 1000); // Run check after cart update
            return { data: cart };
        } catch (e) {
            return Promise.reject(e);
        }
    };

    /**
     * Run checks on every page load (even non-product pages)
     */
    await disableButtonsIfProductInCart();
    observeCartDrawer();

    // Listen for Zipify cart open event
    document.addEventListener('ocu:cart:open', () => {
        console.log("🛒 Detected ocu:cart:open event. Checking cart...");
        disableButtonsIfProductInCart();
    });

    // Listen for clicks on Add to Cart button
    document.addEventListener('click', event => {
        const clickedButton = event.target.closest('.product-form__submit');
        if (clickedButton) {
            console.log("Add to Cart button clicked. Running cart validation...");
            setTimeout(disableButtonsIfProductInCart, 1000);
        }
    });

    // Check for cart updates even on collection/home pages
    setInterval(disableButtonsIfProductInCart, 5000);
});
